/* eslint-disable no-restricted-properties */
/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */
/* eslint-disable import/no-webpack-loader-syntax */

// ENV vars for the Robot Emoji's are dynamically generated by webpack.crc.js
const emojiCodeToWebGL = JSON.parse(process.env.ROBOT_EMOJI_FILES) || {};
const emojiDataCrc32 = JSON.parse(process.env.ROBOT_EMOJI_CRC) || {};

function getRobotEmojiData(ext) {
  const robotEmojiData = {};
  Object.keys(emojiCodeToWebGL).forEach((key) => {
    switch (ext) {
      case 'gif':
        robotEmojiData[key] = require(`$/assets/images/emoji/gif/${emojiCodeToWebGL[key]}.gif`);
        break;
      case 'png':
        robotEmojiData[key] = require(`$/assets/images/emoji/png/${emojiCodeToWebGL[key]}.png`);
        break;
      case 'txt':
        robotEmojiData[key] = require(`!!file-loader?esModule=false!$/assets/robot_emoji_data/${emojiCodeToWebGL[key]}.txt`);
        break;
      default:
        break;
    }
  });
  return robotEmojiData;
}

const gif = getRobotEmojiData('gif');
const png = getRobotEmojiData('png');
const bigEmojiBinaryFileUrl = getRobotEmojiData('txt');

const getEmojiNameByCrc32 = (crc32) => {
  if (!crc32) return 'owl';
  return Object.keys(emojiDataCrc32).find((emojiName) => {
    return emojiDataCrc32[emojiName] === crc32;
  });
};

const fetchBigEmojiDataBuffer = (emojiName) => {
  return new Promise((resolve, reject) => {
    const fileDataUrl = bigEmojiBinaryFileUrl[emojiName];
    console.debug('fetchBigEmojiDataBuffer', fileDataUrl, emojiName);
    fetch(fileDataUrl)
      .then(async (resp) => {
        const buffer = await resp.arrayBuffer();
        resolve(buffer);
      })
      .catch(reject);
  });
};

module.exports = {
  emojiCodeToWebGL,
  emojiDataCrc32,
  gif,
  png,
  bigEmojiBinaryFileUrl,
  getEmojiNameByCrc32,
  fetchBigEmojiDataBuffer,
};
